<template>
    <el-dialog
        :visible="visible"
        ref="DetailDialog"
        :modal-append-to-body="false"
        class="bank-transfer-detail-dialog ah-detail-dialog gray-bg"
        top="10vh"
        append-to-body
        @open="fetchDetail"
        @close="onClose"
    >
        <template slot="title">
            存款帳戶互轉 <span>{{ form.systemNo }}</span>
        </template>
        <div class="detail-card" style="padding: 0">
            <el-form v-loading="isLoading">
                <div class="transfer-info-top">
                    <div class="left info-block">
                        <div class="transfer-to-label">轉出</div>
                        <div class="bnk-nam">
                            {{ form.sourceBankName }}
                        </div>
                        <div class="money-block">
                            <money :v="form.sourceAmt" class="money-value" :precision="form.sourceCny === 'TWD' ? null : 4" />
                            <span class="cny">{{ form.sourceCny }}</span>
                        </div>
                        <div v-if="form.sourceCny !== 'TWD'" class="rat-block">兌換台幣匯率：{{ form.sourceRate }}</div>
                    </div>
                    <div class="arrow">
                        <i class="el-icon-right" style="font-size: 35px; color: #aaa; font-weight: bold" />
                    </div>
                    <div class="right info-block">
                        <div class="transfer-to-label">轉入</div>
                        <div class="bnk-nam">
                            {{ form.targetBankName }}
                        </div>
                        <div class="money-block">
                            <money :v="form.targetAmt" class="money-value" :precision="form.targetCny === 'TWD' ? null : 4" />
                            <span class="cny">{{ form.targetCny }}</span>
                        </div>
                        <div v-if="form.targetCny !== 'TWD'" class="rat-block">兌換台幣匯率：{{ form.targetRate }}</div>
                    </div>
                </div>
                <div class="transfer-info-middle">
                    <div class="left">
                        <ItemBlock label="轉出日期" labelWidth="130">
                            {{ form.transferDate | dateFormater("YYYY-MM-dd") }}
                        </ItemBlock>
                        <ItemBlock label="付款方支付匯費" labelWidth="130">
                            <money :v="form.sourceFee" class="money-value" :precision="form.sourceCny === 'TWD' ? null : 4" />
                            <span class="gray-cny">{{ form.sourceCny }}</span>
                            <ahTip v-if="form.sourceCny !== 'TWD'">
                                約當台幣：
                                <Money :v="form.sourceFee * form.sourceRate" round />
                                <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ form.sourceRate }}</div>
                            </ahTip>
                        </ItemBlock>
                        <ItemBlock label="支出項目" labelWidth="130">
                            <span style="font-size: 10pt">{{ getHierarchyItemNames(form.source_ITEM_SNO) }}</span>
                        </ItemBlock>
                    </div>
                    <div class="right">
                        <ItemBlock label="轉入日期" labelWidth="130">
                            {{ form.transferDate | dateFormater("YYYY-MM-dd") }}
                        </ItemBlock>
                        <ItemBlock label="收款方支付匯款" labelWidth="130">
                            <money :v="form.targetFee" class="money-value" :precision="form.targetCny === 'TWD' ? null : 4" />
                            <span class="gray-cny">{{ form.targetCny }}</span>
                            <ahTip v-if="form.targetCny !== 'TWD'">
                                約當台幣：
                                <Money :v="form.targetFee * form.targetRate" round />
                                <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ form.targetRate }}</div>
                            </ahTip>
                        </ItemBlock>
                        <ItemBlock label="收入項目" labelWidth="130">
                            <span style="font-size: 10pt">{{ getHierarchyItemNames(form.target_ITEM_SNO) }}</span>
                        </ItemBlock>
                    </div>
                </div>
                <div class="transfer-info-bottom">
                    <ItemBlock label="備註">
                        {{ form.note }}
                    </ItemBlock>
                </div>
            </el-form>
        </div>

        <BankTransferFilesView ref="BankTransferFilesView" :form="form" @change="onChangeFiles" @reload="fetchDetail" />

        <AccountingInfoBlock
            :sno="form.sno"
            :qty="form.vocherQty"
            :status="form.vocherStatus"
            :queryType="9"
            :voucher-status-updater="form.voucherStatusUpdateName"
            :voucher-status-update-date="form.voucherStatusUpdateDate"
            @refresh="() => fetchDetail()"
        />
        <div slot="footer">
            <div class="footer">
                <div style="display: flex">
                    <el-popover placement="top" width="600" trigger="click">
                        <div class="bank-transfer-detail-dialog-footer-title">財務收支</div>
                        <el-table :data="form.incomeStatements">
                            <el-table-column width="115" prop="moo" label="單號">
                                <template slot-scope="scope">
                                    <el-button type="text" style="padding: 0" @click="onOpenVariableDetail(scope.row.sno)">
                                        {{ scope.row.moo }}
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="tpc" label="摘要" show-overflow-tooltip></el-table-column>
                            <el-table-column width="75" prop="amt" align="right" label="金額">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.amt" />
                                </template>
                            </el-table-column>
                            <el-table-column width="55" prop="cny" label="幣別">
                                <template slot-scope="scope">
                                    <span style="color: #aaa">{{ scope.row.cny }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div slot="reference" class="other-receipt-info-block info-block clickable" style="width: 180px">
                            <div class="label">財務收支</div>
                            <div class="count">{{ form.incomeStatements.length }}筆</div>
                        </div>
                    </el-popover>
                </div>

                <div class="last-editor-info-block info-block">
                    <div class="label">編輯人</div>
                    <div class="count">
                        {{ form.upD_NAM || form.crT_NAM }}
                        <span v-if="form.upD_DAT" class="space-left">{{ form.upD_DAT | dateFormater("YYYY-MM-dd") }}</span>
                        <span v-else class="space-left">{{ form.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
                    </div>
                </div>
                <el-button v-if="!isQR()" @click="onEditClick">編輯</el-button>
            </div>
        </div>
        <VariableDetailDialog @close="onVariableDetailDialogClose" :visible="variableDetailDialog.visible" :sno="variableDetailDialog.sno" />
    </el-dialog>
</template>
<script>
import BankTransferFilesView from '@/components/dashboard/Finance/VariableStatement/BankTransferFilesView.vue';
import VariableDetailDialog from '@/components/dashboard/Finance/VariableStatement/DetailDialog.vue';
import ItemBlock from './ui/ItemBlock.vue';

export default {
    name: 'VariableStatementDetailDialog',
    components: {
        ItemBlock,
        BankTransferFilesView,
        VariableDetailDialog,
        AccountingInfoBlock: () => import('@/components/ui/AccountingInfoBlock.vue'),
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        sno: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            form: {
                attachments: [],
                crT_DAT: null,
                crT_NAM: null,
                incomeStatements: [],
                note: null,
                sno: null,
                sourceAmt: null,
                sourceBankName: null,
                sourceBankSno: null,
                sourceCny: null,
                sourceFee: null,
                sourceRate: null,
                source_ITEM_SNO: null,
                targetAmt: null,
                targetBankName: null,
                targetBankSno: null,
                targetCny: null,
                targetFee: null,
                targetRate: null,
                target_ITEM_SNO: null,
                transferDate: null,
                upD_DAT: null,
                upD_NAM: null,
            },
            variableDetailDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    computed: {
        statusTxt() {
            switch (this.form.vocherStatus) {
            case 1:
                return '完成';
            case 2:
                return '不作帳';
            default:
                return '待辦';
            }
        },
    },
    methods: {
        async fetchDetail() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: '/AccountTransferRecord/GetRecordDetail',
                    method: 'GET',
                    params: { sno: this.sno },
                });

                this.form = resp.data.detail;
            } finally {
                this.isLoading = false;
            }
        },
        onClose() {
            this.$emit('close', false);
        },

        getHierarchyItemNames(itemNo) {
            const hierarchy = [null, null, null];

            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const t in types) {
                const options = this.$store.getters['statement/statementUiOptions'][types[t].key];
                // eslint-disable-next-line no-restricted-syntax, guard-for-in
                for (const i in options) {
                    const lv1Item = options[i];
                    // eslint-disable-next-line no-restricted-syntax, guard-for-in
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemNo) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return hierarchy.join(' / ');
        },
        onChangeFiles(value) {
            this.form.attachments = value;
        },
        onEditClick() {
            this.$router.push({ name: 'variable-statement-bank-transfer-edit', params: { sno: this.form.sno }, query: { startDate: this.$route.query.startDate, endDate: this.$route.query.endDate } });
        },
        onOpenVariableDetail(sno) {
            this.variableDetailDialog.sno = sno;
            this.variableDetailDialog.visible = true;
        },
        onVariableDetailDialogClose() {
            this.variableDetailDialog.visible = false;
            this.variableDetailDialog.sno = null;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.bank-transfer-detail-dialog {
    .transfer-info-top {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 40px 0;
        border-bottom: 1px solid #bbb;
        .info-block {
            > * {
                text-align: center;
            }
            .transfer-to-label {
                color: $main-color;
                font-weight: bold;
                margin-bottom: 10px;
                font-size: 12pt;
            }
            .bnk-nam {
                font-size: 15pt;
                font-weight: bold;
                margin-bottom: 20px;
            }
            .money-block {
                margin-bottom: 10px;
                .money-value {
                    font-size: 18pt;
                }
                .cny {
                    margin-left: 5px;
                }
            }
            .rat-block {
                color: #888;
            }
        }
    }
    .transfer-info-middle {
        display: grid;
        grid-template-columns: 1fr 1fr;
        padding: 40px 20px;
        border-bottom: 1px solid #bbb;
        gap: 35px;
        > * {
            width: 100%;
        }
        .gray-cny {
            color: #aaa;
            font-size: 10pt;
            margin-left: 5px;
        }
    }
    .transfer-info-bottom {
        display: flex;
        justify-content: space-around;
        padding: 20px 20px 40px;
        > * {
            width: 100%;
        }
    }
    .footer {
        padding-top: 20px;
        display: grid;
        grid-template-columns: 5fr 5fr 1fr;
        align-items: center;
        > * {
            margin-right: 10px;
        }
        &:last-child {
            margin-right: 0;
        }

        .info-block {
            height: 100%;
            border-radius: 8px;
            color: #000000a6;
            background-color: #e6e6ed;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 24px;
            font-size: 11pt;
            &.clickable {
                cursor: pointer;
            }
            .space-left {
                margin-left: 10px;
            }
        }
    }
}
.el-popover .bank-transfer-detail-dialog-footer-title {
    color: $main-color;
    font-weight: bold;
    font-size: 14pt;
    padding-left: 10px;
    margin: 10px 0;
}
</style>
